import { isFeatureEnabled } from 'owa-feature-flags';
import { getComposeEvent, getComposeViewState } from 'owa-calendar-compose-store-manager';
import {
    lazyUpdateCalendarEventCollabSpace,
    lazyGetShareLink,
} from 'owa-calendar-collaborative-space';

export async function updateCollabSpace(formId: string) {
    if (isFeatureEnabled('cal-cmp-fluidCollaborativeSpace')) {
        const event = getComposeEvent(formId);
        const viewStateId = getComposeViewState(formId).collabSpaceViewStateId;
        const shareLinkInfo = await lazyGetShareLink.importAndExecute(viewStateId);

        if (event.CollabSpace || shareLinkInfo?.url?.length > 0) {
            await lazyUpdateCalendarEventCollabSpace.importAndExecute(event, viewStateId, formId);
        }
    }
}
